var _Path, _Path2, _G, _Path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import Svg, { Path, Mask, G } from "react-native-svg";
function SvgAppLogoNoText(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    d: "M155.64 105H0v95l159.931-75.967c15.764-7.488 23.646-11.232 22.767-15.133-.879-3.9-9.606-3.9-27.058-3.9z",
    fill: "#40AFED"
  })), /*#__PURE__*/React.createElement(Mask, {
    id: "app-logo-no-text_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 105,
    width: 183,
    height: 95
  }, _Path2 || (_Path2 = /*#__PURE__*/React.createElement(Path, {
    d: "M155.64 105H0v95l159.931-75.967c15.764-7.488 23.646-11.232 22.767-15.133-.879-3.9-9.606-3.9-27.058-3.9z",
    fill: "#40AFED"
  }))), _G || (_G = /*#__PURE__*/React.createElement(G, {
    mask: "url(#app-logo-no-text_svg__a)"
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M133 105H0v95z",
    fill: "#1A83DF"
  }))), _Path3 || (_Path3 = /*#__PURE__*/React.createElement(Path, {
    d: "M157.546 0H10C5.286 0 2.929 0 1.464 1.464 0 2.93 0 5.286 0 10v190L164.979 16.69c6.455-7.172 9.683-10.758 8.362-13.724C172.02 0 167.195 0 157.546 0z",
    fill: "#40AFED"
  })));
}
export default SvgAppLogoNoText;